<template>
  <div class="dashboardTop">
    <div class="left">
      <div class="home-add-dashboard" v-if="hasWritePermission">
        <DashboardModal
          :isEdit="isEdit"
          :editItem="editItem"
          @close-modal="changeStatus"
          :selectedTemplate="selectedTemplate"
          :templates="getDashboards"
          @onSubmit="onSubmit"
        />
      </div>
      <div class="dropdown-dashboard">
        <div class="dashboard-container-in">
          <div class="heading">{{ selectDashboard }} :</div>
          <RexSelectV3
            :showSearch="true"
            :placeholder="chooseDashboard"
            :value="selectedOption"
            @onPopupScroll="scrollDashboard"
            @onSearch="searchDashboards"
            @onChange="selectDashboards"
            @onDropdownVisibleChange="onOpenSelectField"
            width="14.875rem"
            id="search-select-dashboard-top"
          >
            <template #default>
              <RexSelectOption
                v-for="(obj, i) in getDashboards"
                :key="`${obj.id}-${i}`"
                :value="obj.name"
                :id="obj.id"
              >
                <RexTooltipV3
                  :title="obj.name"
                  placement="right"
                  class="dashboard-opt-tooltip"
                >
                  <div class="dashboard-opt-tooltip-text">
                    {{ obj.name }}
                  </div>
                </RexTooltipV3>
              </RexSelectOption>
              <RexSelectOption
                :disabled="true"
                v-if="isLoading"
                key="loading"
                :value="searchDashboard"
              >
                <div v-if="isLoading" class="dashboard-loading-box">
                  <RexSpinV3 size="small" />
                </div>
              </RexSelectOption>
            </template>
          </RexSelectV3>
        </div>
      </div>
      <div v-if="hasWritePermission" class="make-default">
        {{ $t('makeDefault') }}
        <button class="pin-btn" @click="changePin" id="btn-pin-default">
          <BaseIcon
            :name="active ? 'pinButton' : 'pinButtonGrey'"
            height="2.5rem"
            width="3rem"
          />
        </button>
      </div>
    </div>
    <div class="right" v-if="hasWritePermission">
      <AddWidgetModal v-if="!hideAddWidget" @widget="emitItem" />
      <div class="dashboard-action" v-if="!hideAddWidget">
        <RexDropDownV3 :items="actionsApp" @itemClick="handleIconClick">
          <BaseIcon
            name="menu-icon"
            iconColor="rgb(180, 180, 180)"
            class="dashboard-menu-icon"
          />
        </RexDropDownV3>
      </div>
    </div>

    <RexModalV3
      :show="showDelModal"
      @onClose="cancelDelete"
      @onSubmit="confirmDelete"
      :title="$t('deleteDashboard')"
      :submitText="$t('delete')"
    >
      <template #body>
        <div class="d-flex del-body pb-4">
          {{ $t('deleteDashboardConfirm') }}
          {{ delGroupItem?.name }} ?
        </div>
      </template>
    </RexModalV3>
  </div>
</template>

<script>
import RexSearchSelect from '../../rex-components/RexSearchSelect.vue';
import BaseIcon from '../../rex-components/BaseIcon.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import DashboardModal from './CustomDashboard/DashboardModal.vue';
import AddWidgetModal from './CustomDashboard/AddWidgetModal.vue';
import { CustomService } from '@/services/api/custom.service';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { notificationSucess } from '@/utils/notification';
import _ from 'lodash';
import RexDropDownV3 from '@/rex-components/RexDropDownV3.vue';
import {
  addDashboardIconItems,
  defaultDashboards,
  DELETE,
  EDIT,
} from '@/components/Home/utils/constants';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import { RexSelectOption } from '@/rex-components/rex.comp.config';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import {
  PAGE_SIZE_SCROLL,
  SELECT_FIELD_DEBOUNCE_DURATION_IN_MS,
  SELECT_FIELD_THROTTLE_DURATION_IN_MS,
} from '@/utils/constants';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { usePermissions } from '@/hooks/usePermissions';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

const { hasCapabilityPermission } = usePermissions();

export default {
  components: {
    RexSearchSelect,
    BaseIcon,
    RexModalV3,
    DashboardModal,
    AddWidgetModal,
    RexSelectOption,
    RexDropDownV3,
    RexSelectV3,
    RexTooltipV3,
    RexSpinV3,
  },
  name: 'CustomDashboardComp',
  data: function () {
    return {
      loadingApp: true,
      stylingAddWidget: {
        height: '2.5rem',
        width: '7.375rem',
      },
      searchDashboard: this.$t('searchDashboard'),
      selectDashboard: this.$t('selectDashboard'),
      chooseDashboard: this.$t('chooseDash'),
      newCreatedDash: false,
      dashboardTotalPages: 0,
      dashboardCurrentPage: 0,
      searchKeyword: '',
      selectedOption: '',
      isLoading: false,
      services: [],
      selectedTemplate: {
        id: '',
        label: 'Choose template',
      },
      getCurrentDashboard: { label: this.$t('choose-dashboard'), id: '' },
      getDashboards: [],
      getDashboardsNew: [],
      isEdit: false,
      editItem: {},
      showDelModal: false,
      isDelete: false,
      delGroupItem: {},
      actionsApp: addDashboardIconItems,
      initialDashboardsLoaded: false,
      customDashboards: [],
    };
  },
  computed: {
    ...mapGetters('globalState/user', {
      dashboardGetter: 'getDashboard',
    }),
    ...mapState('homeState', ['defaultDashBoard', 'selectedDashboard']),
    active() {
      if (this.defaultDashBoard.id === this.getCurrentDashboard?.id)
        return true;
      else return false;
    },
    hasWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();

      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
    hideAddWidget() {
      if (
        !this.getCurrentDashboard?.id ||
        this.getCurrentDashboard?.id === 'default' ||
        this.getCurrentDashboard?.id === 'defaultBeta'
      )
        return true;
      else return false;
    },
  },

  methods: {
    ...mapActions('globalState/user', {
      updateUserDashboard: 'updateDashboard',
    }),
    ...mapMutations('homeState', [
      'setSelectedWidgetId',
      'setDefaultDashboard',
      'setSelectedDashboard',
    ]),
    emitItem(item) {
      this.$emit('widget', item);
    },
    makeEdit(grp) {
      this.isEdit = true;
      this.editItem = grp;
    },
    showIcon(id) {
      return id === 'default' || id === 'defaultBeta';
    },
    makeDelete(grp) {
      this.delGroupItem = grp;
      this.showDelModal = true;
    },
    async getAllDashboardsDefault(newCreated = false) {
      const hasConfigPermission = hasCapabilityPermission('CONFIG');

      try {
        this.isLoading = true;
        await CustomService.getAllDashboards({
          page: this.dashboardCurrentPage,
          size: PAGE_SIZE_SCROLL,
          searchKeyword: this.searchKeyword,
        })
          .then((resp) => {
            let data = _.cloneDeep(resp.data.data);
            this.dashboardTotalPages = Math.ceil(
              resp.data?.total / PAGE_SIZE_SCROLL,
            );
            if (data && Array.isArray(data)) {
              this.getDashboards =
                this.dashboardCurrentPage === 0
                  ? data
                  : [...this.getDashboards, ...data];
            }
            this.getDashboards = this.getDashboards.map((item) => ({
              name: item.name,
              id: item.id,
            }));

            this.customDashboards = [...this.getDashboards];

            if (
              this.searchKeyword === '' &&
              (this.getDashboards.length === 0 ||
                (this.getDashboards[0].id !== 'default' &&
                  this.dashboardCurrentPage === 0))
            ) {
              if (hasConfigPermission) {
                this.getDashboards.unshift(...defaultDashboards);
              }
            }
            if (this.searchKeyword != '') {
              const filteredDashboards = this.getDashboardsNew.filter(
                (dashboard) =>
                  dashboard.name
                    .toLowerCase()
                    .includes(this.searchKeyword.toLowerCase()),
              );
              if (filteredDashboards.length > 0) {
                this.getDashboards = filteredDashboards.concat(
                  this.getDashboards,
                );
              }
            }
            if (
              !hasConfigPermission &&
              ['', 'default', 'defaultBeta'].includes(this.selectedDashboard.id)
            ) {
              this.getCurrentDashboard = this.getDashboards?.[0];
              this.selectedOption = this.getDashboards?.[0]?.name;
              this.selectDashboards('', {
                id: this.getDashboards?.[0]?.id,
                value: this.getDashboards?.[0]?.name,
              });
            } else {
              this.getCurrentDashboard = this.selectedDashboard;
              this.selectedOption = this.selectedDashboard.name;
            }

            this.$emit('onMountEvenet', this.selectedDashboard.id);
          })
          .catch((error) => console.log('error', error));
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    onOpenSelectField(open) {
      if (open && this.searchKeyword) {
        this.dashboardCurrentPage = 0;
        this.searchKeyword = '';
        this.getAllDashboardsDefault();
      }
    },
    scrollDashboard: throttle(function (event) {
      const target = event.target;
      if (
        !this.isLoading &&
        target.scrollTop + target.offsetHeight >= target.scrollHeight - 10 &&
        this.dashboardCurrentPage < this.dashboardTotalPages
      ) {
        this.dashboardCurrentPage += 1;
        this.getAllDashboardsDefault();
      }
    }, SELECT_FIELD_THROTTLE_DURATION_IN_MS),
    searchDashboards: debounce(function (val) {
      this.dashboardCurrentPage = 0;
      this.searchKeyword = val;
      this.getAllDashboardsDefault();
    }, SELECT_FIELD_DEBOUNCE_DURATION_IN_MS),
    selectDashboards(_, option) {
      this.selectedOption = option?.value;
      const selectedDashboard = { name: option?.value, id: option.id };
      this.getCurrentDashboard = selectedDashboard;
      this.$emit('changeDashboard', selectedDashboard);
      this.setSelectedWidgetId(selectedDashboard.id);
      this.setSelectedDashboard(selectedDashboard);
      if (this.searchKeyword) {
        this.searchKeyword = '';
        this.dashboardCurrentPage = 0;
        this.getAllDashboardsDefault();
      }
    },
    async deleteDashboard() {
      try {
        await CustomService.deleteDashboard(this.delGroupItem.id)
          .then((resp) => {
            this.dashboardCurrentPage = 0;
            this.getAllDashboardsDefault();
            if (resp.data.success) {
              notificationSucess(this.$t('dashboardDeleted'));
              if (this.getCurrentDashboard.id === this.delGroupItem.id) {
                this.setSelectedWidgetId('default');
                this.getCurrentDashboard = { name: 'Standard', id: 'default' };
                this.setSelectedDashboard(this.getCurrentDashboard);
                if (this.delGroupItem.id === this.defaultDashBoard.id) {
                  this.setDefaultDashboard(this.getCurrentDashboard);
                }
                this.selectedOption = this.getCurrentDashboard?.name;
              }
              if (this.dashboardGetter === this.delGroupItem.id) {
                this.updateUserDashboard('default');
              }
            }
          })
          .catch((error) => console.log('error', error));
      } catch (error) {
        console.log(error);
      }
    },
    onSubmit(dashboard) {
      if (this.editItem.name === this.defaultDashBoard.name) {
        this.setDefaultDashboard(dashboard);
      }
      this.setSelectedDashboard(dashboard);
      this.changeDashboard(dashboard);
      this.dashboardCurrentPage = 0;
      this.getAllDashboardsDefault();
    },
    deleteWidget() {
      console.log('deleteWidget clicked');
    },
    addDashboard() {
      console.log('addDashboard clicked');
    },
    addWidget() {
      this.$emit('addWidget', true);
    },
    changeDashboard(item) {
      this.getCurrentDashboard = item;
      this.selectedOption = this.getCurrentDashboard?.name;
      this.$emit('changeDashboard', item);
      this.setSelectedWidgetId(item.id);
    },
    changePin() {
      let newDashboard = this.getCurrentDashboard.id;
      this.setDefaultDashboard(this.getCurrentDashboard);
      this.updateUserDashboard(newDashboard)
        .then((msg) => {
          notificationSucess(this.$t('dashboardUpdated'));
          this.selectedOption = this.getCurrentDashboard?.name;
        })
        .catch((error) => console.log('error', error));
    },
    confirmClick() {
      this.isDelete = !this.isDelete;
    },
    cancelDelete() {
      this.isDelete = false;
      this.showDelModal = false;
    },
    confirmDelete() {
      this.isDelete = true;
      if (this.isDelete) {
        this.deleteDashboard();
      }
      this.showDelModal = false;
    },
    changeStatus() {
      this.isEdit = false;
    },
    handleIconClick(item) {
      switch (item.key) {
        case EDIT:
          this.isEdit = true;
          this.editItem = item;
          this.editItem = this.getCurrentDashboard;
          break;
        case DELETE:
          this.delGroupItem = item;
          this.delGroupItem = this.getCurrentDashboard;
          this.showDelModal = true;
          break;
      }
    },
  },
  created() {
    this.setSelectedDashboard(this.defaultDashBoard);
    this.getCurrentDashboard = this.defaultDashBoard;
    this.selectedOption = this.defaultDashBoard.name;
    this.getAllDashboardsDefault();
  },
  watch: {
    // updateUserDashboard() {}
    dashboardGetter() {
      this.getAllDashboardsDefault();
    },
    defaultDashBoard(newValue) {
      this.setSelectedDashboard(newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboardTop {
  @include flex-center-justify(space-between);
  margin-top: 0.6875rem;
  // margin-right: 0.6235rem;
  border-bottom: 0.0625rem solid $line-separator;
  padding-bottom: 0.6875rem;
}
.left {
  display: flex;
}
.home-add-dashboard {
  margin-right: 1.4375rem;
}
.dropdown-dashboard {
  text-align: left;
}
.make-default {
  @include flex-center;
  margin-left: 1rem;
  color: $font-primary;
}
.right {
  margin-left: auto;
  display: flex;
}
.pin-btn {
  border: none;
  background: none;
  @include svg-fill-pointer($color-brand-accent);
}
.dashboard-action {
  margin-top: 0.5rem;
}
.dashboard-menu-icon {
  padding: 0rem 0.5rem;
  cursor: pointer;
}
.dashboard-loading-box {
  @include flex-center;
  height: 100%;
  width: 100%;
}
.dashboard-opt-tooltip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
}
.dashboard-opt-tooltip {
  overflow: hidden;
  white-space: nowrap;
}
.heading {
  margin-top: 0.3rem;
  font-size: 1.25em;
  color: $color-white;
  font-family: $semi-bold;
  margin-right: 0.5625em;
}
.dashboard-container-in {
  display: flex;
}
</style>
